export const clearAllStorage = async () => {
  try {
    // Clear localStorage
    localStorage.clear()

    // Clear sessionStorage
    sessionStorage.clear()

    // Clear cookies
    document.cookie.split(';').forEach((cookie) => {
      const [name] = cookie.split('=')
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
    })

    // Clear Caches API
    if ('caches' in window) {
      const cacheNames = await caches.keys()
      await Promise.all(cacheNames.map((cache) => caches.delete(cache)))
    }

    console.log('All storage cleared successfully.')
  } catch (error) {
    console.error('Error clearing storage:', error)
  }
}
